function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.03 22h-7.04a.749.749 0 110-1.5h7.04a.749.749 0 110 1.5zm-7.39-5.31c.39.39.39 1.02 0 1.42l-2.98 2.98a3.027 3.027 0 01-4.07.18c-.07-.06-.13-.12-.19-.18l-.87-.87-1.79-1.79-.86-.86c-.07-.07-.13-.14-.19-.21a3.01 3.01 0 01.19-4.04l2.98-2.98a.996.996 0 011.41 0l6.37 6.35zm7.48-6.05l-5 5a.996.996 0 01-1.41 0L8.34 9.29c-.39-.39-.39-1.02 0-1.42l5-4.99a3.024 3.024 0 014.26 0l3.52 3.51a3.012 3.012 0 010 4.25z"
})));